import { SB } from '@play-co/replicant';

export const socialSchema = {
  // Platform friends; allows us to calculate mutual friends
  // Empty object; might want to add more properties later
  friends: SB.map(SB.object({})),

  // Flag to show player's online status
  isOnline: SB.boolean(),

  social: SB.object({
    invites: SB.map(
      SB.object({
        timeSent: SB.number(),
        referralRewardClaimed: SB.boolean(),
      }),
    ),
  }),
};
